import type { FC } from "react";
import { Link } from "react-router-dom";

export type EmailConnectionRequiredBannerProps = {
  /** バナーに表示するメッセージ. 省略時はデフォルト文 */
  message?: string;
};

/**
 * Gmail 連携が無いユーザー向けに、設定画面への導線を出すバナー.
 * 1:1 送信 (返信 / 提案) を使う画面の上部に表示する.
 * @param {EmailConnectionRequiredBannerProps} props props
 * @return {JSX.Element} バナー
 */
export const EmailConnectionRequiredBanner: FC<
  EmailConnectionRequiredBannerProps
> = ({ message }) => {
  return (
    <div className="alert alert-warning text-xs py-2 px-3">
      <span className="flex-1">
        {message ??
          "返信・提案メールの送信には Gmail 連携が必要です。連携設定からご利用のアカウントを連携してください。"}
      </span>
      <Link
        to="/profile?tab=integrations"
        className="link link-primary text-xs"
      >
        連携設定へ
      </Link>
    </div>
  );
};
